import React from 'react';
import { AiFillCaretDown, AiOutlineCheck } from 'react-icons/ai';
import Cookies from 'js-cookie';
import classes from './SelectToggle.module.css'

interface SelectToggleOption {
  [key: string]: any; // Allow any properties since we use dynamic keys
}

interface SelectToggleProps {
  title: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedItems: string[];
  setSelectedItems: (items: string[] | ((prev: string[]) => string[])) => void;
  options: SelectToggleOption[] | null;
  cookieKey: string;
  idKey: string;
  nameKey: string;
  defaultSelectId?: number;
}

const SelectToggle = ({
  title,
  isOpen,
  setIsOpen,
  selectedItems,
  setSelectedItems,
  options,
  cookieKey,
  idKey,
  nameKey,
  defaultSelectId,
}: SelectToggleProps) => {
  const HandleButtonToggle = () => {
    if (isOpen) {
      Cookies.set(cookieKey, selectedItems);
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  const HandleItemSelectChange = (itemId: number, isSelected: boolean) => {
    // selectedItems needs to be strings to be stored in cookies
    setSelectedItems((prevState: string[]) => {
      return isSelected
        ? prevState.filter(id => id !== String(itemId))
        : [...prevState, String(itemId)];
    });
  };

  const SelectOptions = () => (
    <div className={classes.selectOptions}>
      {options?.map((option: SelectToggleOption) => (
        <SelectOption key={option[idKey]} option={option} />
      ))}
    </div>
  );

  const SelectOption = ({ option }) => {
    const isDefaultSelected = defaultSelectId === option[idKey];
    const isManuallySelected = selectedItems.includes(String(option[idKey]));
    const isSelected = isDefaultSelected || isManuallySelected;

    return (
      <span
        onClick={() => HandleItemSelectChange(option[idKey], isSelected)}
        className={isSelected ? classes.selected : null}
      >
        <label htmlFor={option[nameKey]}>{option[nameKey]}</label>
        {isSelected ? <AiOutlineCheck /> : null}
      </span>
    );
  };

  return (
    <div className={classes.container}>
      <button onClick={HandleButtonToggle}>
        <span>{title}</span>
        <span
          className={
            isOpen ? classes.toggleArrowActive : classes.toggleArrow
          }
        >
          <AiFillCaretDown />
        </span>
      </button>
      {isOpen && <SelectOptions />}
    </div>
  );
};

export default SelectToggle;
